import React, { ReactNode } from 'react';
import NavMenu from './NavMenu';
import { Toaster } from '../components/ui/sonner';
interface LayoutProps {
  children?: ReactNode;
  userInfo?: any | null;
}

const Layout: React.FC<LayoutProps> = ({ children, userInfo }) => {
  return (
    <div>
      <Toaster
        visibleToasts={9}
        duration={4000}
        //!makes it bg-black for some reason
        // toastOptions={{
        //   classNames: {
        //     cancelButton: 'bg-[white!important] text-[black!important]',
        //   },
        // }}
      />
      {children}
    </div>
  );
};

export default Layout;
